import styled from "styled-components";
import {LiveCasinoNavbarDefaultBox} from "./live-casino-navbar.default.box";

export const LiveCasinoNavbarCasino777Box = styled(LiveCasinoNavbarDefaultBox)`
    background-image: url(${props => props.theme.images.texture.toString()});
`;
